import { useEffect, useState } from 'react';

import {
  listMyList, MyListItem, MY_LIST_CHANGE_EVENT,
} from '../lib/myList';

/** Subscribe to My List; re-reads on local + cross-tab changes. */
export const useMyList = (): MyListItem[] => {
  const [items, setItems] = useState<MyListItem[]>(() => listMyList());

  useEffect(() => {
    const handler = () => setItems(listMyList());
    window.addEventListener(MY_LIST_CHANGE_EVENT, handler);
    window.addEventListener('storage', handler);
    return () => {
      window.removeEventListener(MY_LIST_CHANGE_EVENT, handler);
      window.removeEventListener('storage', handler);
    };
  }, []);

  return items;
};

/** True while saved; re-renders on change. */
export const useIsFavorited = (schoolId: number): boolean => {
  const items = useMyList();
  return items.some((i) => i.schoolId === schoolId);
};
